import React from "react";
import { BulkInsertLearningPaths } from "../../components/ManagerPortal/InsertLP/BulkInsertLearningPaths";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { Box } from "grommet";

export const BulkInsertLearningPathsPage = () => {
  return (
    <Box fill="vertical" justify="between">
      <HeaderNavigation />
      <Box flex="grow" pad="medium">
        <BulkInsertLearningPaths />
      </Box>
      <StickyFooter />
    </Box>
  );
};
